module.exports = __webpack_public_path__ + "static/img/27.4df22b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/27.png
// module id = 2m1K
// module chunks = 1